import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private historyStack: string[] = [];
  private routerEventsSub: Subscription;

  constructor(
    private router: Router,
    private location: Location,
  ) {}

  init(): void {
    this.routerEventsSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEnd = event as NavigationEnd;
        const topOfStack = this.historyStack[this.historyStack.length - 1];

        if (navigationEnd.urlAfterRedirects !== topOfStack) {
          this.historyStack.push(navigationEnd.urlAfterRedirects);
        }
      });
  }

  clear(): void {
    this.historyStack = [];
  }

  back(defaultBackRoute: string = '/'): void {
    this.historyStack.pop();

    if (this.historyStack.length > 0) {
      // There is internal app history — use browser back
      this.location.back();
    } else {
      // Direct entry (deep-link) — navigate to the fallback route
      this.router.navigateByUrl(defaultBackRoute);
    }
  }

  ngOnDestroy(): void {
    if (this.routerEventsSub) {
      this.routerEventsSub.unsubscribe();
    }
  }
}
